import { match } from "ts-pattern";

import type { Login } from "@ctrl/controller-rpc";

function parse(v: string | null): unknown {
  if (!v) return null;
  try {
    return JSON.parse(v);
  } catch {
    return null;
  }
}

export function paramsOfUrl(url: URL, referral_id?: string): Login {
  const authentication = (() => {
    const new_user = parse(url.searchParams.get("new_user"));
    const device_id = url.searchParams.get("device_id");
    const device_token = url.searchParams.get("device_token");
    if (
      typeof new_user === "boolean" &&
      device_id !== null &&
      device_token !== null
    )
      return {
        new_user,
        device_id,
        device_token,
        referral_id,
      };
    else return undefined;
  })();
  const intention: Login = match(url.searchParams.get("intention"))
    .with(null, () => {
      return { intention: "login" } satisfies Login;
    })
    .with("add_account", () => {
      const claimed = parse(url.searchParams.get("claimed"));
      const token = url.searchParams.get("token");
      return typeof claimed === "boolean" && token !== null
        ? ({
            intention: "add_account",
            claimed,
            token,
          } satisfies Login)
        : ({ authentication, intention: "login" } satisfies Login);
    })
    .with("join_organization", () => {
      const invitation_token = url.searchParams.get("invitation_token");
      return invitation_token !== null
        ? ({
            authentication,
            intention: "join_organization",
            invitation_token,
          } satisfies Login)
        : ({ authentication, intention: "login" } satisfies Login);
    })
    .with("login", () => {
      return {
        authentication,
        intention: "login",
      } satisfies Login;
    })
    .with("grant_scopes", () => {
      return { intention: "grant_scopes" } satisfies Login;
    })
    .otherwise(() => {
      // eslint-disable-next-line no-console
      console.error(`unrecognized login URL ${url}`);
      return { intention: "login" };
    });
  return { ...intention, current_url: url.toString() };
}
